import React from 'react';
import '../App.css';

const Pagination = ({ currentPage, totalPages, onPageChange, itemsPerPage, totalItems }) => {
  const getPageNumbers = () => {
    const pages = [];
    const maxPagesToShow = 5;
    let startPage = Math.max(1, currentPage - Math.floor(maxPagesToShow / 2));
    let endPage = Math.min(totalPages, startPage + maxPagesToShow - 1);
    
    if (endPage - startPage < maxPagesToShow - 1) {
      startPage = Math.max(1, endPage - maxPagesToShow + 1);
    }
    
    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    return pages;
  };

  if (totalItems === 0) {
    return (
      <div
        className="pagination-wrapper"
        style={{
          marginTop: '16px',
          padding: '12px 16px',
          color: 'var(--text-secondary)',
          fontSize: '0.875rem'
        }}
      >
        No rows match the current filters.
      </div>
    );
  }

  if (totalPages <= 1) return null;

  return (
    <div className="pagination-wrapper" style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginTop: '24px',
      marginBottom: '16px',
      padding: '16px',
      background: 'var(--bg-secondary)',
      borderRadius: '12px',
      border: '1px solid var(--border-color)',
      flexWrap: 'wrap',
      gap: '16px',
      width: '100%',
      boxSizing: 'border-box'
    }}>
      <div className="pagination-info" style={{ color: 'var(--text-secondary)', fontSize: '0.875rem' }}>
        Showing {((currentPage - 1) * itemsPerPage) + 1} to {Math.min(currentPage * itemsPerPage, totalItems)} of {totalItems} results
      </div>
      <div className="pagination-controls" style={{ display: 'flex', gap: '8px', alignItems: 'center', flexWrap: 'wrap' }}>
        <button
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className="btn btn-outline"
          style={{
            padding: '8px 16px',
            fontSize: '0.875rem',
            opacity: currentPage === 1 ? 0.5 : 1,
            cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
            minHeight: '44px',
            minWidth: '44px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
          title="Previous page"
        >
          ←
        </button>
        
        {getPageNumbers().map((page) => (
          <button
            key={page}
            onClick={() => onPageChange(page)}
            className={currentPage === page ? 'btn btn-primary' : 'btn btn-outline'}
            style={{
              padding: '8px 12px',
              fontSize: '0.875rem',
              minWidth: '44px',
              minHeight: '44px'
            }}
          >
            {page}
          </button>
        ))}
        
        <button
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          className="btn btn-outline"
          style={{
            padding: '8px 16px',
            fontSize: '0.875rem',
            opacity: currentPage === totalPages ? 0.5 : 1,
            cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
            minHeight: '44px',
            minWidth: '44px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
          title="Next page"
        >
          →
        </button>
      </div>
    </div>
  );
};

export default Pagination;

